import GeneralStatus from "@/models/Shared/GeneralStatus";

export default (value: number) => {
    switch (value) {
        case GeneralStatus.ActiveOrApproved:
            return "Active";
        case GeneralStatus.Archived:
            return "Archived";
        case GeneralStatus.Deleted:
            return "Deleted";
        default:
            return "Unknown";
    }
} 